import React from 'react';
import EvaluatorPaymentsBaseTab from './EvaluatorPaymentsBaseTab';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import EvaluatorPaymentReviewItem from '../../../../Domain/EvaluatorPaymentReviewItem';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import EvaluatorPaymentsSearchParams from './EvaluatorPaymentsSearchParams';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import InvoiceEvaluatorBaseService from '../../../../Services/InvoiceEvaluatorBaseService';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import AuthService from '../../../../Services/authService';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';

export default class AllPaymentsTab extends EvaluatorPaymentsBaseTab {
  constructor(props) {
    super(props);
    if (props.assignment && props.assignment.asId) {
      InvoiceEvaluatorBaseService.IsNewPaymentRequestButtonEnabled(props.assignment.asId)
        .then((result) => {
          this.setState({ isNewPaymentRequestEnabled: result });
        })
        .catch(() => {
          ErrorMessage.SetErrorMessage('APT25');
        });

      InvoiceEvaluatorBaseService.IsNewAdvancePaymentButtonEnabled(props.assignment.asId)
        .then((result) => {
          this.setState({ isNewAdvancePaymentEnabled: result });
        })
        .catch(() => {
          ErrorMessage.SetErrorMessage('APT33');
        });
    }

    EvaluatorPaymentReviewItem.statusChangeFunction = this.statusChangeFunction.bind(this);
  }

  statusChangeFunction(item) {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedItem: item,
    });
  }

  getType() {
    return 'all_payments';
  }

  clickOnNewPaymentRequest(selectedId, selectedItem) {
    this.setState({ shownPanel: ShownPanelsEnum.AddNewItem });
  }

  clickOnNewAdvancePayment(selectedId, selectedItem) {
    this.setState({ shownPanel: ShownPanelsEnum.AddNewSubItem });
  }

  renderActionButtons() {
    const actionsDisabled = !this.state.itemList.find((il) => il.Selected && il.IeType !== 'Payment Request');

    const userOfficeId = AuthService.getInstance().GetLoggedInUser().officeId;

    // prettier-ignore
    const areOfficesTheSame =
      AuthService.IsAdmin()
      ? true
      : !this.props.assignment
        ? false
        : OfficeHelper.IsSameOfficeGroup(userOfficeId, this.props.assignment.asLdvid);

    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-regular fa-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnNewPaymentRequest(),
            tooltip: 'New Payment Request',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: !this.state.isNewPaymentRequestEnabled,
            hidden: !this.props.newButtonsEnabled,
          },
          {
            iconName: 'fa-regular fa-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnNewAdvancePayment(),
            tooltip: 'New Advance Payment',
            roleKey: 'EvaluatorPayment_NewAdvancePaymentButton',
            disabled: !this.state.isNewAdvancePaymentEnabled || !areOfficesTheSame,
            hidden: !this.props.newButtonsEnabled,
          },
          {
            iconName: 'fa-regular fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected && il.IeType !== 'Payment Request').map((il) => il.IeId),
                'Approve'
              ),
            tooltip: 'Approve',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: actionsDisabled,
            hidden: !this.props.newButtonsEnabled,
          },
          {
            iconName: 'fa-regular fa-xmark',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected && il.IeType !== 'Payment Request').map((il) => il.IeId),
                'Void'
              ),
            tooltip: 'Void',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: actionsDisabled,
          },
          {
            iconName: 'fa-solid fa-rotate-right',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected && il.IeType !== 'Payment Request').map((il) => il.IeId),
                'VoidAndReissue'
              ),
            tooltip: 'Void & Reissue',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: actionsDisabled,
          },
          {
            iconName: 'fa-solid fa-trash',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList.filter((il) => il.Selected && il.IeType !== 'Payment Request').map((il) => il.IeId),
                'VoidAndSupress'
              ),
            tooltip: 'Void & Supress',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: actionsDisabled,
          },
        ]}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        {this.renderActionButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          type={EvaluatorPaymentReviewItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorPaymentService.GetEvaluatorPayments}
          convertDBItemsFunction={EvaluatorPaymentService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={EvaluatorPaymentsSearchParams}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          errorCode='APT93'
        />
      </div>
    );
  }
}
